import React, { useState, useEffect, useMemo } from "react";

import iccrLogo from "images/logo/iccrr-logo.png";
import gyan from "images/logo/gyan.jpg";
//import audioResource from "images/gayatri-mantra-flute-mp3-ringtone-download.mp3";
import audioResource from "images/Veena_Kinhal_-_01_-_Haratanaya_Sree.mp3";
import clappingAudioResource from "images/mixkit-conference-audience-clapping-strongly-476.wav"

import CurtainRevealBox from 'react-curtain-reveal';

const CurtainReveal = (props) => {
  const [showBanner, setShowBanner] = useState(true);
  const [audio] = useState(() => new Audio(audioResource));
  const [playing, setPlaying] = useState(true);

  const [clappingAudio] = useState(() => new Audio(clappingAudioResource));
  const [clapPlaying, setClapPlaying] = useState(false);

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  }, [playing]);

  useEffect(() => {
    clapPlaying ? clappingAudio.play() : clappingAudio.pause();
  }, [clapPlaying]);

  useEffect(() => {
    audio.loop = true;
    audio.addEventListener('ended', () => setPlaying(false));
    audio.addEventListener("canplaythrough", (event) => {
      setPlaying(true);
    });
    return () => {
      setPlaying(false);
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, []);

  return (
    <div style={{width:"100%", height:"100%", "align-items": "center", "justify-content": "center"}}>
        {(showBanner) && (
	  <div className="login-logo curtain-top-banner row self-align-center" style={{ "height": "100%"}}>
	    <div className="col-12 self-align-center">
	      <div className="row self-align-center">
		<div className="col-12 center">
		  <span className="image-cropper" style={{ "width": "auto", "borderRadius": "1%", "background": "transparent", "display": "flex" }}>
		    <img src={iccrLogo} className="logo-pic ic" alt="logo" />
		  </span>
		</div>
	      </div>
	    </div>
	    <div className="col-12 self-align-center">
	      <div className="row self-align-center">
		<div className="col-12 self-align-center">
		  <span style={{"textAlign": "center", "color": "white", "margin": "20px", "height": "50vh"}}>
		    <h1>Welcome to the launch of<br/>Gyan Setu Application</h1>
		  </span>
		</div>
	      </div>
	    </div>
	  </div>
	)}
        <CurtainRevealBox
            onReveal={() => { console.log("revealed");  setShowBanner(!showBanner); setPlaying(false); setClapPlaying(true);}}
            onHide={() => { console.log("hide"); setShowBanner(!showBanner); setPlaying(true); setClapPlaying(false);}}
            styleConfig={{
                curtain: {
                "border-radius": "1%",
                },
                leftPanel: {
                "background": "repeating-linear-gradient(90deg, blue, skyblue 50px)"
                //"background": "linear-gradient(90deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%ck)"
                },
                rightPanel: {
                "background": "repeating-linear-gradient(90deg, blue, skyblue 50px)"
                //"background": "linear-gradient(270deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)"
                },
                content: {
                //backgroundColor: "rgba(34,193,195,1)"
                }
            }}
            animationConfig={{
                variant: "linear",
                speed: 5
            }}
            revealCheck={() => {
                  return Math.random() <= 0.5;
                }}
            stayHidden={false}
            >
                <p className="curtain-content-background" ></p>
        </CurtainRevealBox>
    </div>
  );
}

export default CurtainReveal;
